import { Layout } from "components/common"
import Image from "next/legacy/image"
import { apiPayment } from "api"
import { useEffect, useRef, useState } from "react"
import { LoadingSub, Modal, notification } from "components/ui"
import useStore from "components/ui/Context"
import LoginForm from "components/ModalLogin/LoginForm"
import { numberToCurrency, numberToPhone } from "lib/func"
import PurchaseError from "utils/PurchaseError"
import PaymentType from "utils/PaymentType"
import Link from "next/link"
import { BreadcrumbSubcription } from "components/Breadcrumb"
import BreadcrumbMobile from "components/Breadcrumb/BreadcrumbMobile"
import { useRouter } from "next/router"

function renderTitle(view) {
  if (view === "change") return "Xác nhận đăng ký gói mới"
  if (view === "cancel") return "Cách thức hủy gói"
  return "Cách thức đăng ký gói"
}
export default function SubscriptionsDetail({ subId, deviceType }) {
  const { togleModalLogin, userInfo } = useStore()
  const [items, setItems] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [selected, setSelected] = useState()
  const [selectPaymentType, setSelectPaymentType] = useState()
  const [variants, setVariants] = useState([])
  const [checkView, setCheckView] = useState()
  const [step, setStep] = useState(1)
  const [purchase, setPurchase] = useState({})
  const [purchaseExist, setPurchaseExist] = useState("")
  const [loading, setLoading] = useState(false)
  const __paymentType = useRef(PaymentType.PAYMENT_SMS)
  const [isMessage, setIsMessage] = useState()

  const router = useRouter()
  // console.log({ selected })
  async function fetch() {
    setLoading(true)
    try {
      const { data, success } = await apiPayment.getDetailPackage(subId, {
        platform: 6
      })
      if (data) {
        setItems(data)
        setSelected(data[0]?.id)
        fecthProduct(data[0]?.id)
        if (data?.is_sms) {
          __paymentType.current = PaymentType.PAYMENT_SMS
        } else {
          __paymentType.current = PaymentType.PAYMENT_GATE
        }
      }
    } catch (error) {
      console.log(error.response)
      if (error) {
        notification.error({ message: error })
      }
    } finally {
      setLoading(false)
    }
  }
  async function onFinish() {
    if (!userInfo?.id) {
      togleModalLogin()
      return
    }
    setLoading(true)
    let _purchase = {}
    let __paramCheckPucharge = {
      platform: 6,
      payment_type: __paymentType.current
    }
    if (userInfo?.phone) {
      try {
        const { data, success } = await apiPayment.CheckUser(selected, __paramCheckPucharge)
        if (__paymentType.current === PaymentType.PAYMENT_SMS) {
          setPurchaseExist(data?.name)
          const result = items.find((item) => item.id === selected)
          _purchase = result
          if (!success) return
          if (data?.upgrade) {
            setCheckView("register")
            setStep(2)
          } else {
            _purchase.message = data.message
            _purchase.sms_cancel_syntax = data.sms_cancel_syntax
            _purchase.sms_register_syntax = data.sms_register_syntax
            setStep(1)
            if (data?.code === PurchaseError.DuplicateProduct) {
              setCheckView("cancel")
            } else {
              setCheckView("change")
            }
          }
          setIsOpen(true)
        } else {
          const result = items.find((item) => item.id === selected)
          _purchase = result
          _purchase.message = data.message
          _purchase.sms_cancel_syntax = data.sms_cancel_syntax
          _purchase.sms_register_syntax = data.sms_register_syntax

          if (data.upgrade) {
            if (
              data?.code === PurchaseError.DuplicateProduct ||
              data?.code === PurchaseError.PackageLevelSame ||
              data?.code === PurchaseError.ExistProduct ||
              data?.code === PurchaseError.SamePackageLevelLower
            ) {
              setIsOpen(true)
              setStep(1)
              setCheckView("not_sms")
            } else {
              callPaymentGate(selectPaymentType.product_id)
            }
          } else {
            setIsOpen(true)
            setStep(1)
            setCheckView("not_sms")
          }
        }
      } catch (error) {
        console.log(error.response)
        notification.error({ message: error })
        setLoading(false)
      }
      setPurchase(_purchase)
      setLoading(false)
    } else {
      console.log("lot vao day")
      setIsOpen(false)
      setCheckView("updatePhone")
      setIsOpen(true)
    }
  }

  function onChangeProduct(id) {
    setSelected(id)
    fecthProduct(id)
  }
  function onChangePaymentType(item) {
    __paymentType.current = item?.payment_type
    setSelectPaymentType(item)
  }

  async function fecthProduct(id) {
    try {
      const { data } = await apiPayment.getProduct(id, { platform: 6 })
      setVariants(data)
      setSelectPaymentType(data?.product_variants[0])
      __paymentType.current = data?.product_variants[0]?.payment_type
    } catch (error) {
      console.log(error)
    }
  }
  async function callPaymentGate(id) {
    setIsMessage("")
    let __param = {
      language: "vi",
      product_id: id,
      currency_code: "VND"
    }
    try {
      const { data, success } = await apiPayment.getUrlPaygate(__param)
      if (success) {
        if (data?.url) {
          if (window !== undefined) {
            if (isSafariOniPhone()) {
              router.push(data?.url)
            } else {
              let a = document.createElement("a")
              a.setAttribute("href", data?.url)
              a.setAttribute("target", "_blank")
              a.click()
            }
          }
        }
        if (data.message) {
          notification.error({ message: data.message })
          setIsMessage(data?.message)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const isSafariOniPhone = () => {
    const userAgent = navigator.userAgent
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent)
    const isiPhone = /iPhone/i.test(userAgent)

    return isSafari && isiPhone
  }

  function onChangeStep() {
    if (selectPaymentType.payment_type === 3) {
      __paymentType.current = 3
      callPaymentGate(selectPaymentType.product_id)
      // setIsOpen(false)
    } else {
      setStep(2)
    }
  }

  useEffect(() => {
    fetch()
  }, [subId])

  return (
    <main className="max-w-screen-xl m-auto p-4 mb-8 text-dark-100">
      <div className="mt-6 md:mt-14">
        <div>{deviceType === "desktop" ? <BreadcrumbSubcription step={1} /> : <BreadcrumbMobile step={1} />}</div>
      </div>
      <LoadingSub loading={loading}>
        <div className="md:grid grid-cols-12 mt-10 gap-8">
          <div className="col-span-8">
            <div className="md:grid grid-cols-12 md:p-8 md:bg-dark-500 rounded-2xl">
              <div className="col-span-4 bg-dark-500 mb-4 md:mb-0 fix_img">
                {items.length > 0 && (
                  <Image
                    className="rounded-lg cursor-pointer"
                    src={items[0]?.package?.image_uri}
                    width={400}
                    height={225}
                    alt="?"
                  />
                )}
              </div>
              <div className="text-sm md:text-base flex-auto overflow-auto scroll__video h-36 md:px-4 pb-4 col-span-8 md:bg-dark-500">
                <div className="text-dark-100 font-semibold mb-4">{items[0]?.package?.name}</div>
                <div className="text-dark-100">
                  <div dangerouslySetInnerHTML={{ __html: items[0]?.package?.description.replace(/\n/g, "<br />") }} />
                </div>
              </div>
            </div>
            <div className="col-span-12">
              <div className="my-6 gap-8">
                <div className="md:grid grid-cols-12 gap-4">
                  <div className="font-semibold text-lg  text-primary-300 col-span-12 mb-4">
                    Đăng ký gói phù hợp với bạn
                  </div>
                  {items.length > 0 &&
                    items.map((item, index) => {
                      const {
                        price,
                        name,
                        period_text,
                        id,
                        unlimited_time,
                        is_using,
                        is_bonus,
                        period_bonus_text,
                        description
                      } = item
                      const classs =
                        selected === id ? "bg-dark border-dark border-[3px]" : "border-[3px] border-same-theme"

                      return (
                        <div key={id} className="mb-4 md:mb-0 col-span-6">
                          <button onClick={() => onChangeProduct(id)} tabIndex={"0"} onKeyDown={() => {}}>
                            <div className={`${classs} rounded-lg p-2 md:p-4 flex items-center cursor-pointer bg-dark`}>
                              <div className="rounded-full min-w-[20px] h-5 w-5 border border-gray-500 flex items-center justify-center">
                                {selected === id && <div className="rounded-full bg-green-500 h-[14px] w-[14px]" />}
                              </div>
                              <div className="pl-2 md:pl-4 text-left w-full" htmlFor={`radio-${index}`}>
                                <div className="flex justify-between">
                                  <div className="text-dark-100 font-semibold text-sm">{name}</div>
                                  {is_using && (
                                    <div className="flex items-center px-3 py-1 bg-[#25C685] rounded-lg font-medium h-6">
                                      <span className="mr-1">{iconMark}</span>
                                      <span className="w-[85px] text-xs font-semibold">Đang sử dụng</span>
                                    </div>
                                  )}
                                </div>
                                <div className="text-dark-300 py-1 text-sm">{description}</div>
                                <div>
                                  <span className="text-green">{numberToCurrency(price)} VNĐ</span>{" "}
                                  <span className="text-primary-300">
                                    /{unlimited_time === true ? <>Không thời hạn</> : <>{period_text}</>}
                                  </span>
                                  {is_bonus && (
                                    <span className="px-2 py-1 rounded bg-[#FFAD00] text-sm ml-4">
                                      {period_bonus_text}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </button>
                        </div>
                      )
                    })}

                  <div className="font-semibold text-lg my-4 text-primary-300 col-span-12">Phương thức thanh toán</div>
                  {variants
                    ? variants?.product_variants?.map((item) => {
                        const { payment_type, id } = item

                        const classs =
                          selectPaymentType.id === id
                            ? "bg-dark border-dark border-[2px]"
                            : "border-[2px] border-same-theme"
                        return (
                          <button
                            key={id}
                            onClick={() => onChangePaymentType(item)}
                            tabIndex={"0"}
                            className="col-span-6"
                            onKeyDown={() => {}}
                          >
                            <div className={`${classs} rounded-lg px-4 py-2 flex items-center cursor-pointer bg-dark`}>
                              <div className="rounded-full min-w-[20px] h-5 w-5 border border-gray-500 flex items-center justify-center">
                                {selectPaymentType.id === id && (
                                  <div className="rounded-full bg-green-500 h-[14px] w-[14px]" />
                                )}
                              </div>
                              <div className="flex items-center ">
                                {payment_type === PaymentType.PAYMENT_GATE && (
                                  <div className="ml-4 text-dark-100 font-medium flex items-center">
                                    <Image
                                      className="rounded cursor-pointer"
                                      src={"https://stvinaprod.vtvcab.vn/ead952fb-6ee0-48ff-8cae-40845ebc3c9a.png"}
                                      width={32}
                                      height={32}
                                      alt="?"
                                    />
                                    <div className="ml-2">Cổng thanh toán VTVcab</div>
                                  </div>
                                )}
                                {payment_type === PaymentType.PAYMENT_SMS && (
                                  <div className="ml-4 text-dark-100 font-medium flex items-center">
                                    <Image
                                      className="rounded cursor-pointer"
                                      src={"https://stvinaprod.vtvcab.vn/dc96148e-b6c3-496d-87f7-ea002b23c0bf.png"}
                                      width={32}
                                      height={32}
                                      alt="?"
                                    />
                                    <div className="ml-2">Thanh toán qua SMS</div>
                                  </div>
                                )}
                                {payment_type === PaymentType.PAYMENT_IAP_IOS && (
                                  <div className="ml-4 text-dark-100 font-medium flex items-center">
                                    <Image
                                      className="rounded cursor-pointer"
                                      src={"https://stvinaprod.vtvcab.vn/ead952fb-6ee0-48ff-8cae-40845ebc3c9a.png"}
                                      width={32}
                                      height={32}
                                      alt="?"
                                    />
                                    <div className="ml-2">Thanh toán in-app|iOSS</div>
                                  </div>
                                )}
                                {payment_type === PaymentType.PAYMENT_IAP_ANDROID && (
                                  <div className="ml-4 text-dark-100 font-medium flex items-center">
                                    <Image
                                      className="rounded cursor-pointer"
                                      src={"https://stvinaprod.vtvcab.vn/ead952fb-6ee0-48ff-8cae-40845ebc3c9a.png"}
                                      width={32}
                                      height={32}
                                      alt="?"
                                    />
                                    <div className="ml-2">Thanh toán in-app|android</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </button>
                        )
                      })
                    : null}

                  {/* <button
            className="w-full bg-primary-500 p-4 rounded text-dark font-bold text-base leading-6"
            onClick={onFinish}
          >
            ĐĂNG KÝ GÓI
          </button> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className=" bg-dark p-6 rounded-xl h-58 text-dark-300">
              <div className="py-2 font-semibold text-lg">Thông tin chi tiết:</div>
              <div className="flex justify-between py-1">
                <div className="w-[100px] min-w-[100px]">Tài khoản:</div>
                <div className="text-dark-100">{userInfo?.phone}</div>
              </div>
              <div className="flex justify-between py-1">
                <div className="w-[100px] min-w-[100px]">Tên gói:</div>
                <div className="text-dark-100 text-end">{variants?.name}</div>
              </div>
              <div className="flex justify-between py-1">
                <div className="w-[100px] min-w-[100px]">Thời hạn gói:</div>
                <div className="text-dark-100">{variants?.period_text}</div>
              </div>
              <div className="flex justify-between py-1">
                <div className="w-[100px] min-w-[100px]">Thành tiền:</div>
                <div className="text-green">{selectPaymentType?.price?.toLocaleString()} VNĐ</div>
              </div>
            </div>
            <div className="mt-7 mb-4 text-center underline">
              <Link href={"/dieu-khoan-giao-dich"}>Điều khoản giao dịch</Link>
            </div>

            <button
              className="w-full bg-primary-500 p-4 rounded-lg text-dark font-bold text-base leading-6"
              onClick={onFinish}
            >
              Thanh toán
            </button>
          </div>
        </div>
      </LoadingSub>
      <Modal
        isOpen={isOpen}
        onCancel={() => {
          setIsOpen(false)
          setLoading(false)
        }}
        showIcon={step === 2}
      >
        {checkView === "updatePhone" && <LoginForm initView="updatephone" onClose={() => setIsOpen(false)} />}
        {step === 1 && checkView !== "updatePhone" && (
          <div className="p-6 text-center bg-dark max-w-md w-[420px]">
            <div className="text-dark-100 font-semibold mb-4 text-xl">Thông báo</div>
            <div>
              <div className="mb-4 text-dark-300">{purchase?.message}</div>
              {checkView === "login" && <div className="mb-4">Bạn cần đăng nhập để sử dụng tính năng này</div>}
              <hr className="mt-6" style={{ borderTop: "solid 0.5px", opacity: "0.3" }} />
              <div className="mt-4">
                <button className="p-2" onClick={() => setIsOpen(false)}>
                  Đóng
                </button>
                {checkView === "cancel" && (
                  <button className="text-red-500 p-2 ml-8" onClick={onChangeStep}>
                    Hủy gói
                  </button>
                )}
                {checkView === "change" && (
                  <button className="text-red-500 p-2 ml-8" onClick={onChangeStep}>
                    Hủy gói
                  </button>
                )}
                {checkView === "login" && (
                  <button className="p-2 ml-8" onClick={onChangeStep}>
                    Đăng nhập
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="p-6 text-center bg-dark">
            <div className="text-dark-100 font-semibold mb-4 text-xl">{renderTitle(checkView)}</div>
            <div>
              <div className="p-4 text-dark-300 bg-dark-900 rounded">
                <div className="flex justify-between">
                  <div>Số điện thoại</div>
                  <div className="text-dark-100">{numberToPhone(userInfo?.phone)}</div>
                </div>
                <div className="flex justify-between py-2 gap-4">
                  <div>Gói cước</div>
                  <div className="text-dark-100">{checkView === "cancel" ? purchaseExist : purchase?.name}</div>
                </div>

                {checkView !== "cancel" && (
                  <div className="flex justify-between">
                    <div>Thanh toán</div>
                    <div className="text-dark-100">
                      <div>
                        <span>{numberToCurrency(purchase?.price)} VNĐ</span>
                        {/* <span>/{purchase?.period_text}</span> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="p-4 text-dark-300 ">
                {checkView !== "cancel" && <span>chỉ áp dụng với thuê bao Vinaphone</span>}
              </div>
              <div className="p-4 text-dark-100 bg-dark-900 rounded mb-6">
                <div className="text-dark-300">Soạn tin nhắn</div>
                <div className="text-dark-100 mb-2 text-xl">
                  <span className="font-semibold">
                    {checkView === "register" ? purchase?.sms_register_syntax : purchase?.sms_cancel_syntax}
                  </span>
                  <span className="px-4">gửi</span>
                  <span className="font-semibold">{purchase?.service_number}</span>
                </div>
              </div>

              <button
                className="hover:bg-primary-900 p-2 w-full h-12 border border-dark-700 rounded-lg text-primary-500"
                onClick={() => setIsOpen(false)}
              >
                Đã hiểu
              </button>
            </div>
          </div>
        )}
      </Modal>
    </main>
  )
}

SubscriptionsDetail.Layout = Layout

export async function getServerSideProps({ query, req }) {
  const { subId } = query
  const UA = req.headers["user-agent"]
  const isMobile = Boolean(UA.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))

  let deviceType = isMobile ? "mobile" : "desktop"
  return { props: { subId, deviceType } }
}

const iconMark = (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.44443 0.0439453C4.11152 0.0439453 0.566406 3.58906 0.566406 7.92197C0.566406 12.2549 4.11152 15.8 8.44443 15.8C12.7773 15.8 16.3224 12.2549 16.3224 7.92197C16.3224 3.58906 12.7773 0.0439453 8.44443 0.0439453ZM8.44443 14.2244C4.97022 14.2244 2.14201 11.3962 2.14201 7.92197C2.14201 4.44776 4.97022 1.61955 8.44443 1.61955C11.9186 1.61955 14.7468 4.44776 14.7468 7.92197C14.7468 11.3962 11.9186 14.2244 8.44443 14.2244ZM12.0604 4.43988L6.86882 9.6315L4.82842 7.59897L3.71761 8.70977L6.86882 11.861L13.1712 5.55856L12.0604 4.43988Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)
